import React from 'react'
import spacetime from 'spacetime'
import sanityClient from '@sanity/client'
import EventCard from '@/modules/eventCard'

const client = sanityClient({
  projectId: 'wakmcovw',
  dataset: 'production',
  // token: configOptions.accessToken,
  useCdn: false // `false` if you want to ensure fresh data
})
class PastEvents extends React.Component {
  constructor() {
    super()
    this.state = {
      events: []
    }
  }
  componentDidMount() {
    const today = spacetime('now')
    const cleanToday = today.format('').toString()
    const queryEvents = `*[_type == "event" && eventDate < '${cleanToday}'] | order(eventDate desc) {
        ...,
        eventType-> {
          ...,
          'image': image.asset->url,
          'imageId': image.asset._ref
        },
        'image': eventImage.asset->url,
        'imageId': eventImage.asset._ref
      }`

    client.fetch(queryEvents).then(response => {
      this.setState({
        events: response
      })
    })
  }
  render() {
    const {
      events
    } = this.state
    return (
      <div className='event__rows'>
        {events.map(event => (
          <EventCard past key={event._id} {...event} />
        ))}
      </div>
    )
  }
}

export default PastEvents